import React from 'react';
import Carousel, { Dots } from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import dota2 from '../images/dota2.jpg';
import barca from '../images/barca.jpg';
import office from '../images/office.jpg';
import reddit from '../images/reddit.png';
import am from '../images/am.jpg';

class Gallery extends React.Component {
  constructor() {
    super();
    this.state = { value: 0 };
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.setState({ value });
  }

  render() {
    return (
      <div className="me-container">
        <div className="me-description">
          <p>A random collection of things i love!</p>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexFlow: 'row',
            alignContent: 'center',
            textAlign: 'center',
          }}
        >
          {' '}
          <Carousel
            centered
            slidesPerPage={4}
            value={this.state.value}
            onChange={this.onChange}
            slides={[
              <img src={dota2} />,
              <img src={barca} />,
              <img src={office} />,
              <img src={reddit} />,
              <img src={am} />,
            ]}
            arrows
            infinite
            offset={9}
            itemWidth={250}
          />
        </div>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/More.js